module.exports = __webpack_public_path__ + "static/media/artists.59383d01.svg";